import { Mail, Phone, MapPin, Building2 } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <span className="text-xs font-mono uppercase tracking-widest text-cyan-400">Get in touch</span>
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mt-2">Contact Revona Services</h1>
      <p className="text-slate-400 mt-3 max-w-2xl">Questions about a product, licence or service? Reach out — we're here to help, 24/7.</p>

      <div className="grid sm:grid-cols-2 gap-5 mt-10">
        {[
          [Mail, "Email", "revona.eu@gmail.com", "mailto:revona.eu@gmail.com"],
          [Phone, "Phone", "+351 913 286 138", "tel:+351913286138"],
          [MapPin, "Location", "Funchal, Madeira, Portugal", null],
          [Building2, "VAT/NIF", "328 694 647", null],
        ].map(([Ic, t, v, href]) => (
          <div key={t} className="tactical-card p-6 flex items-center gap-4" data-testid={`contact-${t.toLowerCase()}`}>
            <div className="w-12 h-12 rounded-xl bg-[#0A0E1A] border border-[#1E2F4D] flex items-center justify-center"><Ic className="w-6 h-6 text-cyan-400" /></div>
            <div>
              <div className="text-xs text-slate-500">{t}</div>
              {href ? <a href={href} className="text-white font-medium hover:text-cyan-400">{v}</a> : <div className="text-white font-medium">{v}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
